import React, { useContext, useState } from "react";
import { ApiLinkContext } from "../context/ApiLinkContext";
import { LanguageContext } from "../context/LanguageContext";
import translations from "../data/langData";

const SubsCompany = () => {
  const [showModal, setShowModal] = useState(false);
  const { subsJob } = useContext(ApiLinkContext);
  const { language } = useContext(LanguageContext);
  const t = translations[language];
  // Modalı açmaq üçün funksiya
  const handleOpenModal = () => {
    setShowModal(true);
  };

  // Modalı bağlamaq üçün funksiya
  const handleCloseModal = () => {
    setShowModal(false);
  };

  const subsJobArr = Object.entries(subsJob).map((item) => {
    return item[1];
  });

 
  return (
    <>
      <section className="emplyoee section-title py-5">
      <div className="d-flex justify-content-center align-items-center">
          <p className="text-center my-3 fs-6">
            {subsJob && subsJob[0] !== undefined
              ? language == "az"
                ? subsJob[0].description
                : language == "en"
                ? subsJob[0].descriptionEn
                : language == "ru"
                ? subsJob[0].descriptionRu
                : language == "tr"
                ? subsJob[0].descriptionTr
                : language == "de"
                ? subsJob[0].descriptionDe
                : language == "pl"
                ? subsJob[0].descriptionPl
                : ""
              : ""}
          </p>
        </div>
        <div className="container py-5">
          <div className="row g-3">
            {subsJobArr &&
              subsJobArr.length > 0 &&
              subsJobArr.map((item,idx) => {
                return (
                  <div
                    className="col-lg-4 col-md-4 col-sm-12 col-12  "
                    data-aos="fade-up"
                  >
                    <div className="careerBox" style={{border:`1px solid ${item.color ? item.color : "#20AD96"}`}}>
                      {
                        idx == "1" && (
                          <p className="text-center py-2" style={{background:`${item.color ? item.color : "#20AD96"}`}}> {t.populyar}</p>
                        )
                      }
                      <h5 className="text-center mt-5 title">
                        <span style={{ fontWeight: "600",color:`${item.color ? item.color : "#20AD96"}` }}>
                          {language == "az"
                            ? item.subscription_type
                            : language == "en"
                            ? item.subscription_typeEn
                            : language == "ru"
                            ? item.subscription_typeRu
                            : language == "tr"
                            ? item.subscription_typeTr
                            : language == "de"
                            ? item.subscription_typeDe
                            : language == "pl"
                            ? item.subscription_typePL
                            : ""}
                        </span>
                      </h5>
                      <h5 className="text-center  title">
                        <span style={{ fontWeight: "600",color:`${item.color ? item.color : "#20AD96"}`  }}>
                         {item.monthly_price} /{t.month} <br /> 
                         {item.annual_price} /{t.year}{" "}
                        </span>
                      </h5>
                      <ul className="mt-3 ulSubs">
                        {item.included_services.map((i) => {
                          return (
                            <li>
                              <i className="fa-solid fa-check me-1"></i>
                              {language == "az"
                            ? i.service_text
                            : language == "en"
                            ? i.service_textEn
                            : language == "ru"
                            ? i.service_textRu
                            : language == "tr"
                            ? i.service_textTr
                            : language == "de"
                            ? i.service_textDe
                            : language == "pl"
                            ? i.service_textPL
                            : ""}
                            </li>
                          );
                        })}
                        {item.excluded_services.map((i) => {
                          return (
                            <li>
                              <i className="fa-solid fa-close me-1"></i>
                              {language == "az"
                            ? i.service_text
                            : language == "en"
                            ? i.service_textEn
                            : language == "ru"
                            ? i.service_textRu
                            : language == "tr"
                            ? i.service_textTr
                            : language == "de"
                            ? i.service_textDe
                            : language == "pl"
                            ? i.service_textPL
                            : ""}
                            </li>
                          );
                        })}
                      </ul>
                      <div
                        className="d-flex justify-content-center align-items-start"
                        // style={{ marginTop: "50px" }}
                      >
                        <button
                          className={`btn btn-primary btn-hover-secondary btn-width-300`}
                          style={{background:`${item.color && item.color}`}}
                          onClick={handleOpenModal}
                        >
                          {t.abuneol}
                        </button>
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      </section>
      {showModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <div className="modal-header text-center">
              <h4>Abunəlik Seçimi</h4>
              <button className="close-btn" onClick={handleCloseModal}>X</button>
            </div>
            <div className="modal-body">
              <p className='fs-5'>Ən qısa zamanda xidmətinizdəyik.</p>
            </div>
            <div className="modal-footer">
              <button className="btn btn-primary" onClick={handleCloseModal}>Bağla</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SubsCompany;
